import Pagination from '@core/Pagination';

import getTablePaginatorCss from './styles/getTablePaginatorCss';
import { useTableContext } from './TableContext';

const TablePaginator = () => {
  const { pagination, status } = useTableContext();
  const {
    page,
    pageSize,
    setPage,
    setPageSize,
    totalRecords,
    pageSizeInputOptions,
    hidePagination,
    /* eslint-disable @typescript-eslint/no-unused-vars */
    setTotalRecords,
    ...restPaginationProps
  } = pagination;
  if (hidePagination) {
    return null;
  }

  return (
    <div
      css={getTablePaginatorCss}
      data-testid="table-paginator"
      // @ts-expect-error Current version of react doesn't have inert added to its type definitions.
      inert={status === 'progressing' ? 'true' : undefined}
    >
      <Pagination
        showXsNav
        alignment="justified"
        page={page}
        pageSize={pageSize}
        pageSizeInputOptions={pageSizeInputOptions}
        total={totalRecords as NonNullable<number>}
        onPageChange={(event, newPage) => {
          setPage?.(event, newPage);
        }}
        onPageSizeChange={(event, newPageSize) => {
          setPageSize?.(event, newPageSize);
        }}
        {...restPaginationProps}
      />
    </div>
  );
};

export default TablePaginator;
